module.exports = __webpack_public_path__ + "img/banner_viv15o.a69e00e8.jpg";